"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M8.119 19.875h-3.3a.563.563 0 0 1-.562-.562V4.688c0-.31.253-.562.562-.562h3.3a.562.562 0 1 0 0-1.124h-3.3A1.69 1.69 0 0 0 3.131 4.69v14.625a1.69 1.69 0 0 0 1.688 1.688h3.3a.562.562 0 1 0 0-1.124zM19.182 3h-3.3a.562.562 0 1 0 0 1.124h3.3c.31 0 .562.253.562.562v14.625c0 .31-.253.562-.562.562h-3.3a.562.562 0 1 0 0 1.124h3.3a1.69 1.69 0 0 0 1.688-1.688V4.684a1.69 1.69 0 0 0-1.688-1.688z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M18.101 12c0-3.383-2.752-6.135-6.135-6.135S5.831 8.617 5.831 12s2.752 6.135 6.135 6.135 6.135-2.752 6.135-6.135m-6.135 5.01c-2.762 0-5.01-2.248-5.01-5.01s2.248-5.01 5.01-5.01 5.01 2.248 5.01 5.01-2.248 5.01-5.01 5.01"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M14.429 11.719a.56.56 0 0 0-.562.562c0 1.048-.853 1.901-1.901 1.901s-1.901-.853-1.901-1.901a.562.562 0 1 0-1.124 0c0 1.669 1.357 3.025 3.025 3.025s3.025-1.357 3.025-3.025a.56.56 0 0 0-.562-.562M11.414 9.82a.732.732 0 1 1-1.425.336.732.732 0 0 1 1.425-.336m2.547.167a.73.73 0 1 1-1.461 0 .73.73 0 0 1 1.461 0"
  })]
}), 'VirtualTryon');
//# sourceMappingURL=index.js.map